export const stats = [
  { value: "128", label: "追踪中的热点事件", icon: "ri-radar-line" },
  { value: "3.6w+", label: "关联人物与背景", icon: "ri-group-line" },
  { value: "96%", label: "中心瓜扩散完整还原", icon: "ri-map-2-line" },
  { value: "24h", label: "热点持续跟进更新", icon: "ri-time-line" },
];

export const navLinks = [
  { label: "首屏", href: "#top" },
  { label: "辐射玩法", href: "#mechanics" },
  { label: "瓜田地图", href: "#map" },
  { label: "热门瓜榜", href: "#hot" },
  { label: "追瓜手记", href: "#feed" },
  { label: "口碑", href: "#praise" },
  { label: "常见问题", href: "#faq" },
];

export const mechanicsRings = [
  {
    title: "中心瓜",
    desc: "事件最初的爆发点，一次爆料、一段物料或一条热搜的起点。",
    icon: "ri-fire-line",
  },
  {
    title: "关联人物",
    desc: "顺着关系网向外扩散，找到被卷入的每一个人与立场。",
    icon: "ri-user-shared-2-line",
  },
  {
    title: "背景故事",
    desc: "往前翻时间线，补齐人物过往、前史与动机，让瓜有厚度。",
    icon: "ri-file-history-line",
  },
  {
    title: "周边衍生瓜",
    desc: "主瓜引发的支线：回应、扒料、站队与新的转折点。",
    icon: "ri-route-line",
  },
  {
    title: "全网扩散",
    desc: "记录舆论在各平台的发酵路径，看见一只瓜如何滚成雪球。",
    icon: "ri-share-forward-line",
  },
];

export const trackingSteps = [
  {
    step: "01",
    title: "锁定中心瓜",
    desc: "从全网热搜、爆料与物料里，第一时间锁定事件的核心引爆点。",
  },
  {
    step: "02",
    title: "绘制关联网络",
    desc: "把涉事人物、机构与关系线铺开，形成可视化的瓜田关系网。",
  },
  {
    step: "03",
    title: "补全背景时间线",
    desc: "回溯过往事件与公开信息，还原每个人物行动的来龙去脉。",
  },
  {
    step: "04",
    title: "标注扩散路径",
    desc: "追踪热搜排序、转发裂变与二次发酵，画出舆论扩散地图。",
  },
  {
    step: "05",
    title: "持续跟进反转",
    desc: "盯住每一条后续声明与回应，让瓜的结局也有始有终。",
  },
];

export const categories = [
  {
    title: "明星瓜田",
    icon: "ri-star-smile-line",
    desc: "影视与歌坛的动态、绯闻与台前幕后",
    count: 23,
    tag: "热度常青",
  },
  {
    title: "综艺现场",
    icon: "ri-camera-lens-line",
    desc: "选秀、真人秀的名场面与选手起落",
    count: 18,
    tag: "实时更新",
  },
  {
    title: "剧集幕后",
    icon: "ri-film-line",
    desc: "选角、撕番、制作内幕与口碑反转",
    count: 16,
    tag: "深度盘点",
  },
  {
    title: "商业热点",
    icon: "ri-price-tag-3-line",
    desc: "品牌营销翻车、联名爆款与公关反转",
    count: 12,
    tag: "高讨论度",
  },
  {
    title: "网红前线",
    icon: "ri-vip-crown-line",
    desc: "主播与博主的起落、争议与再出发",
    count: 15,
    tag: "频繁上新",
  },
  {
    title: "社会事件",
    icon: "ri-chat-3-line",
    desc: "公共议题的发酵、澄清与多方求证",
    count: 9,
    tag: "需谨慎",
  },
  {
    title: "饭圈风暴",
    icon: "ri-heart-3-line",
    desc: "粉丝事件的舆论场与应援争议",
    count: 11,
    tag: "话题密集",
  },
  {
    title: "文化讨论",
    icon: "ri-quill-pen-line",
    desc: "观点碰撞与思潮，关于瓜的观察随笔",
    count: 7,
    tag: "专栏",
  },
];

export type HotEntry = {
  rank: string;
  title: string;
  cat: string;
  heat: string;
  trend: string;
  related: string;
  delta: string;
  rising: boolean;
  center: string;
};

export const hotList: Record<string, HotEntry[]> = {
  today: [
    { rank: "01", title: "新剧《云上之城》未播先炒，主演阵容深夜变动引发关注", cat: "剧集幕后", heat: "98.6", related: "关联 12 人", trend: "扩散 34 平台", delta: "+8%", rising: true, center: "阵容变动" },
    { rank: "02", title: "某选秀歌手合约纠纷发酵，经纪公司声明遭网友逐条回怼", cat: "明星瓜田", heat: "96.2", related: "关联 9 人", trend: "扩散 28 平台", delta: "+12%", rising: true, center: "合约纠纷" },
    { rank: "03", title: "顶流品牌联名款三小时售罄，二级市场溢价近翻倍", cat: "商业热点", heat: "92.7", related: "关联 7 人", trend: "扩散 21 平台", delta: "+3%", rising: true, center: "联名售罄" },
    { rank: "04", title: "素人综艺选手一句话火上热搜，评论区两派彻夜开战", cat: "综艺现场", heat: "88.4", related: "关联 6 人", trend: "扩散 19 平台", delta: "-2%", rising: false, center: "争议发言" },
    { rank: "05", title: "千万粉博主停更两周后回归，复出首播在线人数刷屏", cat: "网红前线", heat: "83.9", related: "关联 5 人", trend: "扩散 16 平台", delta: "+6%", rising: true, center: "停更回归" },
    { rank: "06", title: "冷门老剧因网友考古集体翻红，主演话题再度出圈", cat: "剧集幕后", heat: "79.1", related: "关联 8 人", trend: "扩散 14 平台", delta: "+1%", rising: true, center: "考古翻红" },
    { rank: "07", title: "艺人公益明细引讨论，合作机构出面逐项回应", cat: "明星瓜田", heat: "74.5", related: "关联 6 人", trend: "扩散 12 平台", delta: "-4%", rising: false, center: "公益明细" },
    { rank: "08", title: "年度盛典座位图流出，粉丝连夜绘制应援站位图", cat: "饭圈风暴", heat: "71.3", related: "关联 10 人", trend: "扩散 11 平台", delta: "+9%", rising: true, center: "座位图" },
  ],
  week: [
    { rank: "01", title: "一档真人秀的剪辑争议：节目组回应引发全网考古", cat: "综艺现场", heat: "97.1", related: "关联 14 人", trend: "扩散 40 平台", delta: "+15%", rising: true, center: "剪辑争议" },
    { rank: "02", title: "明星直播翻车名场面，品牌连夜暂停合作", cat: "商业热点", heat: "94.3", related: "关联 8 人", trend: "扩散 33 平台", delta: "+7%", rising: true, center: "直播翻车" },
    { rank: "03", title: "新人演员被扒旧账号，考古与和解各成一派", cat: "明星瓜田", heat: "90.8", related: "关联 11 人", trend: "扩散 27 平台", delta: "-1%", rising: false, center: "旧账号考古" },
    { rank: "04", title: "音乐节演出阵容大换血，主办方致歉并公布退票通道", cat: "文化讨论", heat: "86.6", related: "关联 6 人", trend: "扩散 22 平台", delta: "+4%", rising: true, center: "阵容换血" },
    { rank: "05", title: "博主爆款视频被指借鉴创意，双方各执一词", cat: "网红前线", heat: "82.2", related: "关联 7 人", trend: "扩散 18 平台", delta: "+2%", rising: true, center: "创意借鉴" },
    { rank: "06", title: "老牌综艺被曝嘉宾待遇差异，剧透与澄清齐飞", cat: "综艺现场", heat: "78.9", related: "关联 9 人", trend: "扩散 15 平台", delta: "-3%", rising: false, center: "待遇差异" },
    { rank: "07", title: "动画角色配音阵容引战，主创直播回应创作取舍", cat: "文化讨论", heat: "75.1", related: "关联 5 人", trend: "扩散 13 平台", delta: "+5%", rising: true, center: "配音阵容" },
    { rank: "08", title: "剧组路透照流出，服化道还原度获原著粉好评", cat: "剧集幕后", heat: "72.4", related: "关联 4 人", trend: "扩散 10 平台", delta: "+1%", rising: true, center: "路透服化道" },
  ],
  spread: [
    { rank: "01", title: "从一条闲聊帖到全网热搜：这只瓜三天滚成雪球", cat: "社会事件", heat: "99.0", related: "扩散 52 平台", trend: "经历 3 次反转", delta: "+21%", rising: true, center: "全平台裂变" },
    { rank: "02", title: "两代明星隔空互动考古，时间线完整还原", cat: "明星瓜田", heat: "91.5", related: "扩散 31 平台", trend: "10 年跨度", delta: "+9%", rising: true, center: "隔空考古" },
    { rank: "03", title: "一条声明被逐句拆解，二次解读成为新热点", cat: "商业热点", heat: "88.0", related: "扩散 26 平台", trend: "衍生 9 瓜", delta: "+6%", rising: true, center: "声明拆解" },
    { rank: "04", title: "粉丝团线下应援引发讨论，良性示范上热搜", cat: "饭圈风暴", heat: "81.8", related: "扩散 19 平台", trend: "多个正面案例", delta: "+3%", rising: true, center: "良性应援" },
    { rank: "05", title: "主创离场一年后突然回应，旧瓜被重新翻出", cat: "剧集幕后", heat: "77.6", related: "扩散 16 平台", trend: "衍生 6 瓜", delta: "+2%", rising: true, center: "旧瓜重提" },
  ],
};

export const feedTabs = [
  { key: "all", label: "全部" },
  { key: "method", label: "瓜田方法论" },
  { key: "story", label: "扩散实录" },
  { key: "opinion", label: "观点随笔" },
];

export type FeedItem = {
  tag: string;
  cat: string;
  title: string;
  excerpt: string;
  time: string;
  read: string;
  spread: string;
  img: string;
};

export const feedItems: FeedItem[] = [
  {
    tag: "method",
    cat: "瓜田方法论",
    title: "从一条热搜到全网刷屏：一只瓜的完整发酵路径",
    excerpt: "一个热点到底是怎么从零散爆料走向全网热议的？我们用典型的发酵节点拆解每一次扩散背后真正起作用的机制。",
    time: "今日 09:20",
    read: "12.4w 阅读",
    spread: "追踪 38 条路径",
    img: "https://readdy.ai/api/search-image?query=editorial%20magazine%20collage%20showing%20a%20hot%20topic%20rippling%20outward%20into%20social%20media%20nodes%2C%20warm%20cream%20background%20with%20tomato%20red%20and%20gold%20accents%2C%20flat%20modern%20illustration%20style%2C%20clean%20graphic%20layout&width=900&height=620&seq=feed-method-1&orientation=landscape",
  },
  {
    tag: "method",
    cat: "瓜田方法论",
    title: "为什么有些瓜越挖越多？聊聊周边衍生瓜的扩散逻辑",
    excerpt: "中心瓜往往只是冰山一角。我们梳理了衍生瓜的常见长法：从站队、扒料再到二次解读，帮你更快抓住主线。",
    time: "昨日 18:40",
    read: "9.8w 阅读",
    spread: "收录 21 个案例",
    img: "https://readdy.ai/api/search-image?query=magazine%20editorial%20illustration%20of%20an%20iceberg%20with%20branches%20of%20related%20stories%20spreading%20above%20and%20below%20water%2C%20warm%20cream%20and%20red%20palette%2C%20minimal%20flat%20graphic%20art&width=900&height=620&seq=feed-method-2&orientation=landscape",
  },
  {
    tag: "story",
    cat: "扩散实录",
    title: "一次深夜发声，如何在三小时内点燃三个平台",
    excerpt: "实录一场典型事件的扩散时间线：从首发、转发裂变到媒体跟进，我们逐条标注了关键节点与破圈瞬间。",
    time: "前天 21:15",
    read: "15.2w 阅读",
    spread: "还原 46 个节点",
    img: "https://readdy.ai/api/search-image?query=modern%20editorial%20timeline%20infographic%20illustration%20showing%20social%20media%20posts%20going%20viral%20across%20multiple%20platforms%2C%20warm%20neutral%20background%2C%20red%20and%20gold%20accents%2C%20clean%20minimal%20art&width=900&height=620&seq=feed-story-1&orientation=landscape",
  },
  {
    tag: "story",
    cat: "扩散实录",
    title: "从中心瓜到周边瓜：一次完整瓜田地图的绘制过程",
    excerpt: "用一张真实的关系网图，演示我们如何把一位主角背后的人物线、前史线与支线瓜全部铺开再逐层收敛。",
    time: "09-01 14:30",
    read: "11.3w 阅读",
    spread: "关联 9 位人物",
    img: "https://readdy.ai/api/search-image?query=network%20map%20illustration%20of%20people%20nodes%20connected%20by%20lines%20spreading%20from%20a%20center%20point%2C%20warm%20cream%20and%20tomato%20red%20color%20scheme%2C%20flat%20editorial%20graphic%20design%20style&width=900&height=620&seq=feed-story-2&orientation=landscape",
  },
  {
    tag: "opinion",
    cat: "观点随笔",
    title: "当反转来临时，我们该如何保持理性的瓜田姿态",
    excerpt: "反转不是打脸，而是信息补全。我们聊聊在瓜的浪潮里，怎样既享受吃瓜又别轻易被带节奏。",
    time: "08-28 10:05",
    read: "8.7w 阅读",
    spread: "引发 1300 条讨论",
    img: "https://readdy.ai/api/search-image?query=thoughtful%20editorial%20illustration%20of%20balanced%20scales%20over%20social%20media%20symbols%2C%20warm%20cream%20background%20with%20red%20and%20gold%20touches%2C%20minimal%20flat%20conceptual%20art&width=900&height=620&seq=feed-opinion-1&orientation=landscape",
  },
  {
    tag: "method",
    cat: "瓜田方法论",
    title: "一张图看懂：热点事件的扩散路径是怎么画的",
    excerpt: "面向新朋友的地图速成课。三步看懂我们标注的扩散半径、关联节点与二次发酵，从此看图吃瓜不再迷路。",
    time: "08-22 16:50",
    read: "7.4w 阅读",
    spread: "基础必读",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20simple%20radial%20map%20with%20guiding%20arrows%20and%20labels%2C%20warm%20cream%20background%20with%20tomato%20red%20accents%2C%20clean%20minimal%20infographic%20style&width=900&height=620&seq=feed-method-3&orientation=landscape",
  },
];

export const testimonials = [
  {
    name: "林小满",
    role: "追剧爱好者",
    text: "以前追一个瓜要自己在几个平台来回切，现在打开瓜田地图就能看到完整关系网，连带前史都帮我补上了，省了太多时间。",
    icon: "ri-user-smile-line",
  },
  {
    name: "老周",
    role: "新媒体编辑",
    text: "扩散路径追踪这个思路很实用，做热点选题时拿来参考发酵节点，几乎每次都能踩准破圈的关键点。",
    icon: "ri-edit-2-line",
  },
  {
    name: "苏苏",
    role: "吃瓜老手",
    text: "最打动我的是反转也会持续跟进，不是发完就完事。每一个后续回应都标清楚了，理性吃瓜有了抓手。",
    icon: "ri-megaphone-line",
  },
  {
    name: "阿哲",
    role: "话题观察员",
    text: "手记里的方法论特别诚恳，教你怎么看线索而不是教你跟风站队。这种克制在瓜田里很难得。",
    icon: "ri-lightbulb-line",
  },
];

export type FaqItem = { q: string; a: string };

export const faqs: FaqItem[] = [
  {
    q: "什么是“中心瓜”和“周边衍生瓜”？",
    a: "中心瓜指事件最初爆发的那一个核心引爆点，通常是爆料、物料或热搜的起点；周边衍生瓜则是围绕中心瓜长出来的支线，包括当事人的回应、粉丝站队、二次扒料与后续转折。吃瓜中心会以中心瓜为圆心，把周边衍生瓜逐层梳理清楚。",
  },
  {
    q: "你们的瓜田地图是怎么绘制出来的？",
    a: "我们以“事件为圆心”整理涉事人物、机构与背景信息，先铺开关系网络，再按时间线补全前史，最后标注不同平台的扩散路径。每张地图都会标明信息来源与跟进状态，方便你按图索骥。",
  },
  {
    q: "热点信息会不会出现偏差或反转？",
    a: "热点天然伴随不确定，反转并不少见。我们会同步标注已核实、待求证与更新中的信息，并在出现新声明或新证据时持续修订时间线，把“反转”也当作瓜的一部分完整记录。",
  },
  {
    q: "如何更快追踪一个热点事件的扩散？",
    a: "你可以先定位它的中心瓜，再顺着我们地图上的关联节点逐层向外看；需要实时跟进时，建议开启吃瓜晚报订阅，我们会按热度把值得关注的中心瓜与衍生瓜推送给你。",
  },
  {
    q: "我可以投稿或反馈一只瓜吗？",
    a: "当然可以。如果你发现了值得追踪的热点线索，或觉得某张地图缺了关键一环，欢迎通过底部的“吃瓜晚报”留下邮箱与我们联系，我们会认真核对后再补充进瓜田。",
  },
  {
    q: "内容多久更新一次？",
    a: "热门瓜榜按热度实时滚动更新，追瓜手记通常每个工作日更新 1 至 3 篇，扩散中的事件会随后续声明与回应持续跟进，直至事件告一段落。",
  },
];

export const aboutFeatures = [
  { icon: "ri-focus-2-line", title: "以事件为圆心", desc: "不碎片化罗列热搜，而是围绕事件内核建立完整叙事。" },
  { icon: "ri-archive-drawer-line", title: "重前史与脉络", desc: "不只讲今天，更愿意回溯人物与事件的过往时间线。" },
  { icon: "ri-git-branch-line", title: "关系网可视化", desc: "把零散人物与支线整理成清晰可读的瓜田地图。" },
  { icon: "ri-question-answer-line", title: "理性克制", desc: "区分事实与推断，标注求证状态，鼓励独立思考。" },
];